import { FC } from 'react'
import { ButtonsBlock } from '../../../Edit/components'
import { Modal } from '../../../ui'
import style from './style.m.less'
import { useTranslation } from 'react-i18next'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { notification } from 'antd'

interface ICoordinateDataModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
}

const CoordinateDataModal: FC<ICoordinateDataModal> = ({ isModalVisible, setIsModalVisible }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleOk = () => {
        setIsModalVisible(false)
        navigate('/zd-approval')
        notification.success({
            message: 'Успешно',
            description:
                'Данные по ЗД за 17.02.2022 - 30.02.2022 по ЗГО “Абаканская СЭС” согласованы',
        })
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.wrapper}>
                <div className={style.titleWrapper}>
                    <QuestionCircleOutlined className={style.icon} />
                    <div className={style.header}>{t('zdApprovalItem.sendForRevision')}</div>
                </div>
                <div className={style.message}>{t('zdApprovalItem.modalMessage')}</div>
                <div className={style.buttonsBlock}>
                    <ButtonsBlock
                        confirmAction={handleOk}
                        cancelAction={handleOk}
                        confirmTitle={t('zdApprovalItem.approveButton')}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default CoordinateDataModal
